import bezierEasing from "bezier-easing";

export default bezierEasing;
